import type { DistrictNcesId } from "@nimble/datamodel/types/ncesId";

import DistrictJobDetailsDrawerView from "@/components/shared/jobs/district-job-details-drawer/district-job-details-drawer.view";
import { getJobInterestMessage } from "@/components/shared/jobs/job-view-actions/job-view-actions.container";
import useDistrictData from "@/hooks/data/use-district-data";
import useJobPostingData from "@/hooks/data/use-job-posting";
import useStateConfig from "@/hooks/use-state-config";
import { useTrackJobViewed } from "@/hooks/use-track-job-viewed";
import { MISSING_SCHOOL_NCES_ID } from "@/lib/constants/jobs.constants";
import routes from "@/lib/routes";

interface DistrictJobDetailsDrawerContainerProps {
  jobId: string;
  districtNcesId: DistrictNcesId;
  onClose: () => void;
}

export default function DistrictJobDetailsDrawerContainer({
  jobId,
  districtNcesId,
  onClose,
}: DistrictJobDetailsDrawerContainerProps) {
  const jobQuery = useJobPostingData({ jobId });
  const districtQuery = useDistrictData({ ncesId: districtNcesId });
  const stateConfig = useStateConfig();

  useTrackJobViewed({
    jobId,
    schoolNcesId: MISSING_SCHOOL_NCES_ID,
    districtId: districtNcesId,
    state: stateConfig.abbreviation,
  });

  return (
    <DistrictJobDetailsDrawerView
      jobQuery={jobQuery}
      districtQuery={districtQuery}
      jobHref={routes.getDistrictJob({
        state: stateConfig,
        districtId: districtNcesId,
        jobId,
      })}
      interestMessage={getJobInterestMessage(false, false)}
      onClose={onClose}
    />
  );
}
